import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Stack from '@zenbusiness/zui/Stack';

import { NAME } from '#client/build-env';
import { ErrorStateSection } from '#client/components/ErrorStateSection';
import { PartnerNextUp } from '#client/components/PartnerDash/PartnerNextUp';

function PartnerHome({ partner }) { // eslint-disable-line no-unused-vars
  const { formatMessage } = useIntl();

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <ErrorBoundary fallback={<ErrorStateSection title={formatMessage({ id: 'dashboard.partnerNextUp.title' })} />} id={`${NAME}/pages/PartnerHome#NextUp`}>
        <PartnerNextUp />
      </ErrorBoundary>
    </Stack>
  );
}

PartnerHome.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};

export default PartnerHome;
